import { render, staticRenderFns } from "./EditInboundShipment.vue?vue&type=template&id=06553bfe&"
import script from "./EditInboundShipment.vue?vue&type=script&lang=js&"
export * from "./EditInboundShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports